import type { Metric } from '../types/content';

export const impactMetrics: Metric[] = [
  {
    value: '~50%',
    label: 'Fixed Operating Cost Reduction',
    description: 'Delivered through a strategic outsourcing redesign of the operating model.'
  },
  {
    value: '20+',
    label: 'Global Markets',
    description: 'Broadcasting and content distribution footprint spanning four continents.'
  },
  {
    value: 'Hundreds',
    label: 'Commercial Agreements Negotiated',
    description: 'With major telcos, pay-TV platforms, and broadcasters worldwide.'
  },
  {
    value: '\u20ACM+',
    label: 'Annual Budget Oversight',
    description: 'Multi-million-euro budgets with full cross-functional P&L execution.'
  }
];
